export const apiEndpoint = process.env.REACT_APP_ENDPOINT1
// export const apiEndpoint2 = process.env.REACT_APP_ENDPOINT2
export const sessionLifetime = process.env.REACT_APP_SESSION_LIFETIME ?? 120 // lifetime in minutes
export const version = process.env.REACT_APP_VERSION

// axios config
export const axiosConfig = () => {
  const token = JSON.parse(localStorage.getItem('apiToken'))

  return {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      // 'ngrok-skip-browser-warning': '69420',
    },
  }
}

// local storage with expiration
export function setLocalStorageWithExpiry(key, value) {
  const now = new Date()

  const item = {
    value: value,
    expiry: now.getTime() + sessionLifetime * 60000,
  }
  localStorage.setItem(key, JSON.stringify(item))
}

// export function getLocalStorageWithExpiry(key) {
//   const itemStr = localStorage.getItem(key)

//   // if the item doesn't exist, return null
//   if (!itemStr) {
//     return null
//   }

//   const item = JSON.parse(itemStr)
//   const now = new Date()

//   // compare the expiry time of the item with the current time
//   if (now.getTime() > item.expiry) {
//     // If the item is expired, delete the item from storage
//     // and return null
//     localStorage.removeItem(key)
//     return null
//   }
//   return item.value
// }

export function getLocalStorageWithExpiry(key) {
  return JSON.parse(localStorage.getItem(key))
}

export const selectThemeColors = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: '#006386',
    primary25: '#0063861a',
    neutral10: '#7367f0',
    neutral20: '#ededed',
    neutral30: '#ededed',
  },
})

export const formatInputNumber = (val) => {
  if (!val && val !== 0) return ''
  // Round to 2 decimal places to fix floating-point precision errors
  const roundedVal = Math.round(Number(val) * 100) / 100
  const [integerPart, decimalPart] = String(roundedVal).split('.')
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  return decimalPart ? `${formattedInteger},${decimalPart}` : formattedInteger
}

export const parseFormattedNumber = (value) => {
  if (!value) return 0
  const replaceValue = value.replace(/[^\d,]/g, '')
  const [integerPart, decimalPart] = replaceValue.split(',')

  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

  const formattedValue = decimalPart
    ? `${formattedInteger},${decimalPart}`
    : formattedInteger

  const numericValue =
    parseFloat(formattedValue.replace(/\./g, '').replace(',', '.')) || 0

  return numericValue
}

export const getScoreBgColor = (score) => {
  if (score >= 80) return '#dcfce7'
  if (score >= 60) return '#fef3c7'
  return '#fee2e2'
}

export const getScoreTextColor = (score) => {
  if (score >= 80) return '#15803d'
  if (score >= 60) return '#a16207'
  return '#dc2626'
}

// Working Hours color rule: <= 100 green, > 100 to 120 orange, > 120 red
export const getWorkingHoursBgColor = (score) => {
  if (score <= 100) return '#dcfce7'
  if (score <= 120) return '#fef3c7'
  return '#fee2e2'
}

export const getWorkingHoursTextColor = (score) => {
  if (score <= 100) return '#15803d'
  if (score <= 120) return '#a16207'
  return '#dc2626'
}

export const isCoordinatorGroup = (entity) => {
  if (!entity) return false
  if (entity.isCoordinator) return true
  const val = (
    entity.group ||
    entity.groupType ||
    entity.groupName ||
    entity.role ||
    entity.type ||
    entity.name ||
    ''
  ).toString().toLowerCase()
  return val.includes('coordinator') || val.includes('koordinator')
}

export const getCoordinatorMetricValue = (wageObj, field) => {
  if (!wageObj) return 'N/A'
  const piecesPerHour = wageObj.piecesPerHour ?? wageObj.pieces_per_hour
  if (piecesPerHour === undefined || piecesPerHour === null || Number(piecesPerHour) === 0) {
    return 'N/A'
  }
  const camelVal = wageObj[field]
  const snakeVal = wageObj[field?.replace(/([A-Z])/g, '_$1').toLowerCase()]
  const val = camelVal ?? snakeVal
  if (val === undefined || val === null || val === '') return 'N/A'
  return val
}
